export default [
  [`Размеры`, `XS`, `S`, `M`, `L`],
  [`Российский размер`, `42`, `44`, `46`, `48`],
  [`Рост`, `164`, `170`, `170`, `170`],
  [`Обхват груди(a)`, `84`, `88`, `92`, `96`],
  [`Обхват бедер (b)`, `90`, `94`, `98`, `102`],
  [`Длин юбки c поясом (c)`, `49`, `49`, `49`, `49`],
  [`Ширина талии (d)`, `33,1`, `35,2`, `37,3`, `39,4`],
  [`Ширина бёдер (e)`, `43`, `45`, `47`, `49`],
  [`Ширина низа (f)`, `41`, `43,2`, `45,2`, `47,1`]
];
